import * as React from "react"
import { graphql, useStaticQuery } from "gatsby"
import {
  Twitter,
  Instagram,
  Facebook,
  Youtube,
  Linkedin,
  Whatsapp,
} from "./social-icons"
import {
  Container,
  Flex,
  FlexList,
  Box,
  Space,
  NavLink,
  IconLink,
  VisuallyHidden,
  IconListItem,
} from "./ui"
import { BrandLogoLight } from "./brand-logo"
import Contact from "./contact"
import { checkSection } from "../helper-functions"
import ProvenExpert from "./proven-expert"
import Activecampaign from "./activecampaign"
import Modal from "./modal"

const socialMedia = {
  TWITTER: {
    url: "https://twitter.com",
    name: "Twitter",
    icon: <Twitter />,
  },
  INSTAGRAM: {
    url: "https://instagram.com",
    name: "Instagram",
    icon: <Instagram />,
  },
  FACEBOOK: {
    url: "https://facebook.com",
    name: "Facebook",
    icon: <Facebook />,
  },
  YOUTUBE: {
    url: "https://youtube.com",
    name: "YouTube",
    icon: <Youtube />,
  },
  LINKEDIN: {
    url: "https://linkedin.com/in",
    name: "LinkedIn",
    icon: <Linkedin />,
  },
  WHATSAPP: {
    url: "https://wa.me",
    name: "WhatsApp",
    icon: <Whatsapp />,
  },
}

const getSocialURL = ({ service, username }) => {
  const domain = socialMedia[service]?.url
  if (!domain) return false
  return `${domain}/${username}`
}

const getSocialIcon = ({ service }) => {
  return socialMedia[service]?.icon
}

const getSocialName = ({ service }) => {
  return socialMedia[service]?.name
}

export default function Footer(props) {
  const data = useStaticQuery(graphql`
    query {
      layout {
        footer {
          id
          links {
            id
            href
            text
          }
          contact {
            id
            href
            text
          }
          meta {
            id
            href
            text
          }
          socialLinks {
            id
            service
            username
          }
          image {
            ... on ContentfulAsset {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          link {
            href
            text
          }
          title
          body
        }
      }
    }
  `)

  const { links, contact, meta, socialLinks, image, link, title, body } =
    data.layout.footer

  return (
    <>
      <Box background={checkSection(props.maxIndex)}>
        <Box padding={3}>
          <Activecampaign />
        </Box>
        <Modal />
        <Box paddingTop={3}>
          <ProvenExpert />
        </Box>
      </Box>
      <Contact
        maxIndex={props.maxIndex}
        image={image}
        link={link}
        title={title}
        body={body}
      />
      <Box as="footer" paddingY={4} background={"secondary"}>
        <Container>
          <Space size={4} />
          <Flex variant="start" responsive>
            <NavLink to="/">
              <VisuallyHidden>Home</VisuallyHidden>
              <BrandLogoLight />
            </NavLink>
            <Space />
            <FlexList variant={"columnStart"}>
              {links &&
                links.map((link) => (
                  <li key={link.id}>
                    <NavLink to={link.href}>{link.text}</NavLink>
                  </li>
                ))}
            </FlexList>
            <Space />
            <FlexList variant={"columnStart"}>
              {contact &&
                contact.map((link) => (
                  <li key={link.id}>
                    <NavLink to={link.href}>{link.text}</NavLink>
                  </li>
                ))}
            </FlexList>
            <Space />
            <FlexList variant={"columnStart"}>
              {meta &&
                meta.map((link) => (
                  <li key={link.id}>
                    <NavLink to={link.href}>{link.text}</NavLink>
                  </li>
                ))}
            </FlexList>
            <Space />
            <FlexList variant={"iconGrid"}>
              {socialLinks &&
                socialLinks.map((link) => {
                  const url = getSocialURL(link)
                  return (
                    url && (
                      <IconListItem key={link.id}>
                        <IconLink to={url}>
                          <VisuallyHidden>{getSocialName(link)}</VisuallyHidden>
                          {getSocialIcon(link)}
                        </IconLink>
                      </IconListItem>
                    )
                  )
                })}
            </FlexList>
          </Flex>
        </Container>
        <Space size={3} />
      </Box>
    </>
  )
}
